import TextInput from '~/components/TextInput';
import TextArea from '~/components/TextArea';
import MoneyInput from '~/components/MoneyInput';
import FileUpload from '~/components/FileUpload';
import React from 'react';
import { PackageTypes } from '~/lib/PackageHelpers';
import GateRequiresPaymentProcessor from '~/components/GateRequiresPaymentProcessor';

const InputPackageDetails = ({ data, setData, type }) => {
    return (
        <>
            <TextInput
                id="name"
                label="Name"
                inputClassName="w-full"
                autoFocus={!data?.name}
                value={data?.name || ''}
                onChange={newValue => setData({ ...data, name: newValue })}
            />

            <TextArea
                value={data?.description || ''}
                onChange={value => setData({ ...data, description: value })}
                label="Description"
                id="description"
                className="mt-6"
            />

            {type !== PackageTypes.SUBSCRIPTION && (
                <>
                    <MoneyInput
                        value={data?.price || ''}
                        onChange={value => setData({ ...data, price: value })}
                        placeholder="Free"
                        label="Price"
                        className="mt-6"
                    />
                    <GateRequiresPaymentProcessor className="mt-2" />
                </>
            )}

            <div className="input-label mt-6">Image</div>
            <FileUpload
                value={data?.image}
                onChange={value => setData({ ...data, image: value })}
                id="image"
                accept="image/*"
            />
        </>
    );
};

export default InputPackageDetails;
